import { render, staticRenderFns } from "./PerPage.vue?vue&type=template&id=2d6b9766&"
import script from "./PerPage.js?vue&type=script&lang=js&"
export * from "./PerPage.js?vue&type=script&lang=js&"
import style0 from "./PerPage.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports